import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { useInstanceId } from '../../../../hooks';
import { bridge } from '../../../bridge';
import { getQueryParam } from '../../utils';

type MoveToCategoryProps = {
  deeplink: string;
};

const parseScreensDeeplink = (deeplink: string) => {
  const screenName = getQueryParam(deeplink, 'screen_name');
  const nextToken = getQueryParam(deeplink, 'next_token');

  return {
    screen_name: screenName,
    next_token: nextToken ?? '',
  };
};

export const useMoveToCategory = () => {
  const navigation = useRootStackNavigation();
  const instanceId = useInstanceId();

  return useCallback(
    ({ deeplink }: MoveToCategoryProps) => {
      const params = parseScreensDeeplink(deeplink);

      bridge.openDeeplink(deeplink, {
        webCallback: () => {
          navigation.push('Screens', {
            instanceId,
            ...params,
          });
        },
      });
    },
    [navigation, instanceId],
  );
};
